module.exports = __webpack_public_path__ + "static/media/tf.4dff15db.svg";